import { render } from "./RoleBadge.vue?vue&type=template&id=38f33e90"
import script from "./RoleBadge.vue?vue&type=script&lang=js"
export * from "./RoleBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__